<header class="drag-bar" cdkDragHandle cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <fa-icon icon="arrows-alt"></fa-icon>
    <h1 mat-dialog-title>{{headline}}</h1>
    <span class="spacer"></span>
    <fa-icon class="close-button" icon="times" size="2x" matDialogClose></fa-icon>
</header>
<mat-dialog-content>
    <div class="form-wrapper">
    <app-detail-list-template *ngIf="bvForm$ | async as data; else loading" [AutofocusIndex]="1" [Data]="data" [Editing]="true" [Inline]="true">  </app-detail-list-template>
    <app-document-list-card
        [FileIds]="form.value.documentIds"
        (FileClick)="onFileClick($event)"
        (MergePdfClick)="onMergePdfClick($event)"
        [UploadMenu]="(canUploadFiles$ | async) ? fileUploadMenu : null" style="margin-bottom: 18px"
        [ledgerImportPath]="ledgerImportPath"
        [RemoveButton]="hasEditPermission$ | async"
        (RemoveClick)="removeFile($event)"
        [excludeRemoveButtonFromFiles]="[ledgerImportDocumentId]">
    </app-document-list-card>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="actions">
    <button app-button Inverted type="button" (click)="closeDialog()" Color="cancel">Abbrechen</button>

   <button app-round-button Color="red" *ngIf=" BvId && (hasDeletePermission$ | async)" [IsLoading]="ls.IsLoading$ | async" (click)="deleteBV()"  [matTooltip]="'Löschen'">
        <fa-icon icon="trash"></fa-icon>
    </button>
    <button app-button *ngIf="hasEditPermission$ | async" [Disabled]="form.invalid || ((bvId$ | async) && form.pristine)" [IsLoading]="ls.IsLoading$ | async" (click)="save(true, true)" Color="green">Speichern</button>
</mat-dialog-actions>

<mat-menu #fileUploadMenu>
    <button mat-menu-item (click)="fileSelectDialog()">Datei hinzufügen</button>
    <button mat-menu-item (click)="fileUploadDialog()">Datei hochladen</button>
</mat-menu>

<ng-template #chartOfAccountTemplate >
    <div class="selectChartOfAccounts">
        <mat-form-field>
            <app-select-search
                [placeholder]="'Gegenkonto / Sachkonto'"
                [formControl]="form.controls.gegenkonto"
                [Options]="chartOfAccounts"
                [OptionTemplate]="gegenkontoOptionTemplate"
                [CompareOptions]="CompareSelectSearchChartOfAccountsOptions"
                [SearchFunction]="SelectSearchChartOfAccountsOptionsFunction"
            >
            </app-select-search>
        </mat-form-field>
        <button app-round-button matTooltip="neues Konto anlegen" (click)="newChartOfAccountPopUp(null, AccountTypeEnum.Contra)"><fa-icon icon="plus"></fa-icon></button>
    </div>
</ng-template>
<ng-template #gegenkontoOptionTemplate let-option>
    <app-edit-gegenkonto [ChartOfAccount]="option" (editEvent)="newChartOfAccountPopUp($event)" ></app-edit-gegenkonto>
</ng-template>

<ng-template #sumTemplate >
    <div class="sumInput">
        <mat-form-field class="input-27">
            <input
                matInput
                [placeholder]="'Summe (brutto)'"
                [formControl]="form.controls.amountGross"
                (input)="amountGrossValueChanged()"
                type="number"
            />
            <span class="suffix" matSuffix>€</span>
        </mat-form-field>
        <mat-form-field class="input-27">
            <input
                matInput
                [placeholder]="'Summe (netto)'"
                [formControl]="form.controls.amount"
                (input)="taxPercentageValueChanged()"
                type="number"
            />
            <span class="suffix" matSuffix>€</span>
        </mat-form-field>
        <mat-form-field class="input-27">
            <input
                matInput
                [placeholder]="'MwSt Summe'"
                [formControl]="form.controls.taxValue"
                type="number"
                (input)="taxValueChanged()"
            />
            <span class="suffix" matSuffix>€</span>
        </mat-form-field>
        <mat-form-field class="input-18">
            <input
                matInput
                [placeholder]="'MwSt in %'"
                [formControl]="form.controls.taxPercentageValue"
                (input)="taxPercentageValueChanged()"
                type="number"
            />
            <span class="suffix" matSuffix>%</span>
        </mat-form-field>
    </div>
</ng-template>
<ng-template #payedSumTemplate >
    <div class="sumInput">
        <mat-form-field class="input-27">
            <input
                matInput
                [placeholder]="'Bezahlte Summe (brutto)'"
                [formControl]="form.controls.payedAmountGross"
                (input)="payedAmountGrossValueChanged()"
                type="number"
            />
            <span class="suffix" matSuffix>€</span>
        </mat-form-field>
        <mat-form-field class="input-27">
            <input
                matInput
                [placeholder]="'Bezahlte Summe (netto)'"
                [formControl]="form.controls.payedAmount"
                (input)="payedSumValueChanged()"
                type="number"
            />
            <span class="suffix" matSuffix>€</span>
        </mat-form-field>
        <mat-form-field class="input-27">
            <input
                matInput
                [placeholder]="'MwSt bez. Summe'"
                [formControl]="form.controls.payedTaxValue"
                type="number"
            />
            <span class="suffix" matSuffix>€</span>
        </mat-form-field>
    </div>

</ng-template>
<ng-template #customNameTemplate let-Option>
    <div class="div-chip">
        {{ CustomNameMapFn(Option) }}

        <button mat-icon-button  (click)="deleteCustomName(Option, $event)">
            <fa-icon icon="trash" class="fa-icon-chip"></fa-icon>
        </button>
    </div>
</ng-template>
<ng-template #paymentInformationsTemplate>
    <app-dave-list-card
        [Headline]="'Zahlungen'"
        EmptyText="Keine Zahlungen vorhanden"
        [Data]="paymentInfos$"
        [DisplayedCollums]="['zahlungseingangBetragBrutto', 'zahlungseingangBetragNetto', 'dateString', 'ZahlungseingangZusatz']"
        [TableHeaderCollumsMap]="{
        zahlungseingangBetragBrutto: 'Zahlung Betrag brutto',
        zahlungseingangBetragNetto: 'Zahlung Betrag netto',
        dateString: 'Datum',
        ZahlungseingangZusatz: 'Zusatz'
    }"
        [Clickable]="true"
        (EntryClicked$)="onPaymentInformationAdd($event.index)"
        style="max-height: 50vh"
    >
        <button app-round-button headerButton onlyExpanded (click)="onPaymentInformationAdd()" *ngIf="hasEditPermission$ | async">
            <fa-icon [icon]="'plus'"></fa-icon>
        </button>
    </app-dave-list-card>
</ng-template>
<ng-template #skontoTemplate>
    <div class="skonto-wrapper">
        <mat-form-field class="input-27">
            <input
                matInput
                [placeholder]="'Skonto (brutto)'"
                [formControl]="this.form.controls.discountValueGross"
                type="number"
                (input)="skontoGrossChanged()"
            />
            <span class="suffix" matSuffix>€</span>
        </mat-form-field>
        <!--<fa-icon
            icon="question-circle"
            matTooltip="Summe (brutto) - Bezahlte Summe (brutto) = Skonto (brutto)"
            style="margin: 1rem"
        >
        </fa-icon>-->

        <mat-form-field class="input-27" style="margin-left: 1rem">
            <input
                matInput
                [placeholder]="'Skonto (netto)'"
                [formControl]="this.form.controls.discountValue"
                type="number"
                (input)="skontoChanged()"
            />
            <span class="suffix" matSuffix>€</span>
        </mat-form-field>

        <mat-form-field class="input-18" style="margin-left: 1rem">
            <input
                matInput
                [placeholder]="'Skonto in %'"
                [formControl]="this.form.controls.discountPercentageValue"
                type="number"
                (input)="discountPercentageValueChanged()"
            />
            <span class="suffix" matSuffix>%</span>
        </mat-form-field>

        <button mat-icon-button [disabled]="!this.form.getRawValue().amount || !this.form.getRawValue().payedAmount" (click)="setSkontoForm()" type="button"><fa-icon icon="calculator"></fa-icon></button> <span>Skonto berechnen</span>
        <fa-icon
            icon="question-circle"
            matTooltip="Summe (netto) - Bezahlte Summe (netto) = Skonto (netto)"
            style="margin: 1rem;"
        >
        </fa-icon>
    </div>
</ng-template>
<ng-template #loading>
    <app-loading></app-loading>
</ng-template>
